<template>
  <el-row>
    <el-collapse
      v-model="activeName"
      accordion
    >
      <el-collapse-item
        title="Legenda"
        name="legenda"
      >
        <el-row>
            <UploadLegenda
                label="Aguardando"
                description="Arquivo ainda não começou a ser processado"
            />
            <UploadLegenda
                label="Processando"
                description="Arquivo está sendo processado"
                color="primary"
            />
            <UploadLegenda
                label="Finalizado"
                description="Arquivo foi processado"
                color="success"
            />
        </el-row>
      </el-collapse-item>
      <!--
      <el-collapse-item
        title="Filtros"
        name="1"
      >
        <el-row>
          <el-col :span="8">
            <span>Data de criação</span>
            <br>
            <el-date-picker
              v-model="filtros.dataCriacao"
              type="date"
              placeholder="Selecione um dia"
            />
          </el-col>

          <el-col :span="8">
            <span>Status</span>
            <br>
            <el-select
              clearable
              v-model="filtros.status"
              placeholder="Selecione o tipo de arquivo"
            >
              <el-option
                v-for="item in statusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>

          <el-col :span="8">
            <span>Status</span>
            <br>
            <el-select
              clearable
              v-model="filtros.tipoArquivo"
              placeholder="Selecione o tipo de arquivo"
            >
              <el-option
                v-for="item in arquivoOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="3">
            <el-button type="primary">Filtrar</el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="default">Limpar</el-button>
          </el-col>
        </el-row>
      </el-collapse-item> -->
    </el-collapse>
    <div
      v-loading="loading"
      v-if="loading"
      class="loading"
    />
    <UploadTable
      :tableData="tableData"
      :listar="listarArquivos"
      v-else
    />
  </el-row>
</template>

<script>
import UploadTable from './UploadTable'
import UploadLegenda from './UploadLegenda'

export default {
  name: "UploadStatus",
  components: {
    UploadTable,
    UploadLegenda
  },
  data () {
    return {
      activeName: 'legenda',
      filtros: {
        dataCriacao: "",
        status: "",
        tipoArquivo: "",
      },
      tableData: [],
      loading: false,
      statusOption: [{
        value: 'processando',
        label: 'Processando'
      }, {
        value: 'finalizado',
        label: 'Finalizado'
      }, {
        value: 'processado/inserido',
        label: 'Ignorado porque já foi processado ou inserido'
      }, {
        value: 'aguardando',
        label: 'Aguardando'
      }, {
        value: 'tipoNaoIdentificado',
        label: 'Ignorado porque não identificou o tipo'
      },
      {
        value: 'comErro',
        label: 'Finalizado com erro'
      }],
      arquivoOption: [{
        value: 1,
        label: 'Entrada de estoque'
      }, {
        value: 2,
        label: 'Posição de estoque inicial'
      }, {
        value: 3,
        label: 'Posição de estoque final'
      }, {
        value: 4,
        label: 'Catálogo de preços'
      }],
    };
  },
  async mounted () {
    this.$root.$on('tabStatus', this.listarArquivos)
  },
  methods: {
    async listarArquivos () {
      this.loading = true

      const { data } = await this.axios.get(this.$urls.UPLOAD_FILE_LIST);
      this.tableData = data

      this.loading = false
    },
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
}

.loading {
  height: 10vh;
}
</style>